/* import __COLOCATED_TEMPLATE__ from './native-status.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

import ProjectsAbstractStatusComponent from 'seshy/components/projects/abstract/status';

export default class ProjectsNativeStatusComponent extends ProjectsAbstractStatusComponent {}
